import BasicState from "src/libs/basic-view"


const TITLE_MOCK = "Page title"
const HTML_MOCK = "Html content"
const ROUTE_MOCK = "home"

const BasicViewForm = (props:any) :JSX.Element => {
    return  <BasicState 
        title={TITLE_MOCK}
        html={HTML_MOCK}
        icon="fas fa-home"
        islogged
        route={ {
            id: "1",
            route:  ROUTE_MOCK,
            title: TITLE_MOCK,
            html: HTML_MOCK,
            html_source: "",
            component: "",
            single_data_type: "",
            singled_data_type: "",
            feed_data_type: "",
            is_hidden: false,
            i:0,
            current:0,
            data_type: "",
            module: "",
            thumbnail: "",
            capability:[],
            description: "",
            parent_route: "",
            icon: "fas fa-home",
            realRoute: ROUTE_MOCK,
        }}
    />
}
export default BasicViewForm